export default __webpack_public_path__ + "static/media/piece0.b45596e0.webp";